import React, { useEffect, useState } from "react";
import { Parallax } from "react-scroll-parallax";

const ComingSoon = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const getSpeed = (desktopSpeed) =>
    isMobile ? desktopSpeed * 0.5 : desktopSpeed;

  return (
    <section
      className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6 lg:px-8 min-h-screen flex items-center overflow-hidden scroll-mt-0"
      style={{
        paddingTop: isMobile ? "6rem" : "15rem",
        paddingBottom: isMobile ? "4rem" : "18rem",
        minHeight: isMobile ? "auto" : "924px",
      }}
    >
      {/* Main Glow Container */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[clamp(300px, 50vh, 400px)] pointer-events-none">
        {/* Large Teal Ellipse  */}
        <Parallax speed={getSpeed(-20)} disabled={false}>
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: "clamp(-600px, -80vh, -768px)",
              width: "clamp(1200px, 150vw, 1621px)",
              height: "clamp(600px, 75vh, 833px)",
              background: "#009999",
              borderRadius: "50%",
              filter: "blur(80px)",
              opacity: 1,
            }}
          ></div>
        </Parallax>

        {/* White Ellipse Core */}
        <Parallax speed={getSpeed(12)} disabled={false}>
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: "clamp(-80px, -10vh, -54px)",
              width: "clamp(400px, 60vw, 571px)",
              height: "clamp(50px, 7vh, 68px)",
              background: "#FFFFFF",
              borderRadius: "50%",
              filter: "blur(60px)",
              mixBlendMode: "plus-lighter",
              opacity: 1,
            }}
          ></div>
        </Parallax>

        {/* Additional Cyan Gradient for depth */}
        <div className="absolute inset-0 bg-gradient-radial from-cyan-400/20 via-transparent to-transparent blur-[80px]"></div>
      </div>

      {/*  Responsive and mobile-enabled */}
      <Parallax speed={getSpeed(15)} disabled={false}>
        <div
          className="absolute pointer-events-none"
          style={{ left: "clamp(10%, 15%, 15%)", top: "clamp(20%, 25%, 25%)" }}
        >
          <div
            style={{
              width: "clamp(150px, 30vw, 250px)",
              height: "clamp(150px, 30vw, 250px)",
              background:
                "radial-gradient(circle, rgba(6, 182, 212, 0.2) 0%, transparent 70%)",
              borderRadius: "50%",
              filter: "blur(60px)",
            }}
          ></div>
        </div>
      </Parallax>

      <Parallax speed={getSpeed(-14)} disabled={false}>
        <div
          className="absolute pointer-events-none"
          style={{
            right: "clamp(10%, 20%, 20%)",
            bottom: "clamp(20%, 30%, 30%)",
          }}
        >
          <div
            style={{
              width: "clamp(120px, 25vw, 200px)",
              height: "clamp(120px, 25vw, 200px)",
              background:
                "radial-gradient(circle, rgba(20, 184, 166, 0.15) 0%, transparent 70%)",
              borderRadius: "50%",
              filter: "blur(50px)",
            }}
          ></div>
        </div>
      </Parallax>

      {/* Noise Overlay  */}
      <div
        className="absolute pointer-events-none"
        style={{
          inset: 0,
          width: "100vw",
          height: "1500vh",
          backgroundImage: "url(/images/noise.svg)",
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          opacity: 0.58,
          mixBlendMode: "soft-light",
          left: 0,
          top: 0,
        }}
      />

      <div className="relative z-10 w-full max-w-6xl mx-auto text-center">
        {/* Coming Soon Badge  */}
        <Parallax speed={getSpeed(0)} disabled={false}>
          <div className="mb-6 sm:mb-8 md:mb-12 flex justify-center">
            <span
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "clamp(1.125rem, 4vw, 1.875rem)",
                fontWeight: "400",
                lineHeight: "1.6",
                letterSpacing: "0.13em",
                color: "rgba(219, 249, 254, 1)",
                textAlign: "center",
              }}
            >
              Coming Soon!
            </span>
          </div>
        </Parallax>

        {/* Main Heading  */}
        <Parallax speed={getSpeed(6)} disabled={false}>
          <h2
            className="mb-8 sm:mb-10 md:mb-14"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "clamp(2rem, 8vw, 3.75rem)",
              fontWeight: "400",
              lineHeight: "1.2",
              letterSpacing: "0.08em",
            }}
          >
            The Future is Loading
          </h2>
        </Parallax>

        {/* Description  */}
        <Parallax speed={getSpeed(-5)} disabled={false}>
          <div className="flex justify-center mb-12 sm:mb-16 md:mb-20">
            <p
              className="text-gray-300"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "clamp(1rem, 3.5vw, 1.625rem)",
                fontWeight: "400",
                lineHeight: "1.6",
                letterSpacing: "0.13em",
                maxWidth: "clamp(300px, 80vw, 968px)",
                textAlign: "center",
              }}
            >
              An intelligent and immersive digital experience in AI+XR is on its
              way built on enterprise reliability
            </p>
          </div>
        </Parallax>

        {/* Features and CTA - Responsive spacing and sizing */}
        <div className="flex flex-col items-center justify-center gap-8 sm:gap-12 md:gap-16">
          <Parallax speed={getSpeed(8)} disabled={false}>
            <div
              className="[background:linear-gradient(45deg,#0A0A0A,theme(colors.black-custom)_50%,#0A0A0A)_padding-box,conic-gradient(from_var(--border-angle),theme(colors.slate.600/.48)_80%,_theme(colors.slate.500/.50)_86%,_theme(colors.teal-custom)_90%,_theme(colors.teal-custom)_94%,_theme(colors.teal-custom/.48))_border-box] rounded-xl px-4 py-3 border-2 border-transparent animate-border
              relative animated-border flex justify-between items-center gap-5 font-montserrat tracking-wide font-light "
            >
              <span>Smarter</span> •<span>Immersive</span> •
              <span>Future Ready</span>
            </div>
          </Parallax>

          {/* CTA Button - Responsive */}
          <Parallax speed={getSpeed(10)} disabled={false}>
            <button
              onClick={() => {
                const footer = document.querySelector("footer");
                footer?.scrollIntoView({ behavior: "smooth" });
              }}
              className="bg-white text-black rounded-full font-medium hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "clamp(0.875rem, 2.5vw, 1.125rem)",
                fontWeight: "500",
                padding: "clamp(8px, 2vw, 14px) clamp(16px, 5vw, 32px)",
                height: "clamp(40px, 10vh, 52px)",
                borderRadius: "clamp(20px, 5vw, 100px)",
              }}
            >
              Let's Work Together →
            </button>
          </Parallax>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
